import POLICIES from '../security/policies';

export default {
  path: '/user-verified',
  component: () => import('@/vue-app/layouts/Layout.vue'),
  meta: {
    access_policy: POLICIES.UNAUTHENTICATED,
  },
  children: [
    {
      name: 'UserVerified',
      path: '/',
      component: () => import('@/vue-app/components/onboarding/verify-identity/UserVerifyResult.vue'),
    },
  ],
};
